import { isNativeKeyboardFocusable } from '@shared/domain/utils';

export function isNativeMouseFocusable(element: Element): boolean {
	return (
		!element.hasAttribute('disabled') &&
		(element.getAttribute('tabIndex') === '-1' || isNativeKeyboardFocusable(element))
	);
}
